import React, { useState } from "react";
import GridSquare from "images/grid-square.png";
import Modal from "components/modal";
import Slider from "react-slick";
import VideoPlayer from "components/video-player";

import "./style.scss";

const settings = {
  dots: false,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const ImagesGalleryDesktop = ({ data }) => {
  const [modalShow, setModalShow] = useState(false);
  const [slideActive, setSlideActive] = useState(0);
  const total = data.images?.length;

  return (
    <>
      <div className="flex gap-5 mt-9 container sm:flex-col sm:gap-2">
        <div className="w-2/3 relative rounded-lg overflow-hidden h-[544px] sm:w-full sm:h-96">
          <div className="w-full h-full">
            {data.video.video ? (
              <VideoPlayer videoLink={data.video.video} />
            ) : (
              <img
                src={data.singleImage?.src}
                className="w-full h-full object-cover"
              />
            )}
          </div>
        </div>

        <div className="w-1/3 flex flex-col gap-2 relative sm:max-w-full sm:w-full sm:flex-row sm:gap-2 sm:h-24">
          {data.images
            ?.filter((_, i) => i < 3)
            .map((image, index) => (
              <div className="sm:flex-1 relative overflow-hidden rounded-lg" key={image?._key}>
                <img
                  src={image?.src}
                  className="w-full h-full object-cover max-h-44 cursor-pointer"
                  onClick={() => setModalShow(true)}
                />

                {index == 2 && (
                  <div className="hidden sm:flex absolute top-0 lef-0 w-full h-full bg-gray-800 bg-opacity-60  items-center justify-center pointer-events-none">
                    <p className="paragraph text-white">+{total - 3}</p>
                  </div>
                )}
              </div>
            ))}

          <button
            className="btn btn-white absolute bottom-3 right-3 border-none sm:hidden"
            onClick={() => setModalShow(true)}
          >
            View all pictures
            <img src={GridSquare} alt="view pictures" className="w-6 h-6" />
          </button>
        </div>
      </div>

      {/* modal of images gallery */}
      {modalShow && data.images.length > 0 && (
        <Modal
          isOpen={modalShow}
          onClose={() => {
              setModalShow(false);
              setSlideActive(0);
          }}
          isSlider
        >
          <Slider
            {...settings}
            className="images-gallery-modal"
            afterChange={(current) => {
              setSlideActive(current);
            }}
          >
            {data.images.map((image) => (
              <img key={image?._key} src={image?.src} alt={image?.alt} className="w-full h-full"/>
            ))}
          </Slider>
          <div className="fixed bottom-[20%] md:absolute md:bottom-4 left-1/2 -translate-x-1/2 paragraph-lg text-gray-400 py-2 px-5 bg-black bg-opacity-70 z-30">
            {slideActive + 1}/{total}
          </div>
        </Modal>
      )}
    </>
  );
};

export default ImagesGalleryDesktop;
